import React, { useState, useEffect }  from 'react';
import { SelfReg } from './SelfReg';
import { CompanyReg } from './CompanyReg';
import { FormMessage } from '~c/FormMessage';

import Tabs from '~c/ui/Tabs';
import { createLeadRequest } from '../utils';
import metrikaGoal from '../../../helpers/metrikaGoal';

export const CourseReg = props => {
	const [currentLead, setCurrentLead] = useState('');
	const [userType, setUserType] = useState(props?.user?.type);

	const getCurrentLead = async () => {
		metrikaGoal('sendLead');
		if (props.user){
			const response = await createLeadRequest(props.user, props.eventCode, props.pageCode);
			return response.data.NEW_REGISTRATION_ID;
		}
		return '';
	};

	const cbDataForEduServices = (data) => props.cbDataForEduServices(data);

	const onComponentMount = async () => {
		const leadId = await getCurrentLead();
		setCurrentLead(leadId);
	};

	useEffect(() => {
		if (props?.user?.type) {
			if (props?.user?.type === "company") {
				setUserType('company');
			} else {
				setUserType('person');
			}
		}
		onComponentMount();

		if (props.eventTypes === "CONSULT") metrikaGoal('openRegConsultPage');
		if (props.eventTypes === "EDU") metrikaGoal('openRegEduPage');
	}, []);

	return (
		<div className="registration">
			<h4 className="heading heading--2">Данные для договора</h4>
			<FormMessage className='registration__form-message' extraClass="warning">
				Данная информация необходима для заключения договора и оказания услуг. В дальнейшем её можно будет изменить в Личном кабинете.
			</FormMessage>
			<Tabs
				className='registration__tabs'
				key={[props, currentLead]}
				selectedTabId={userType === "company" ? 1 : 0}
				items={[
					{
						header: 'Физическое лицо',
						onClick: () => setUserType('person'),
					},
					{ 
						header: 'Юридическое лицо',
						onClick: () => setUserType('company'),
					},
				]}
			/>
			<SelfReg
				eventTypes={props.eventTypes}
				cbDataForEduServices={cbDataForEduServices}
				nextStep={props.nextStep}
				isCompanyReg={userType === "company"}
				currentLead={currentLead}
				eventCode={props.eventCode}
				pageCode={props.pageCode}
				user={props.user}
				checkPolicy={props.checkPolicy}
				sendUsersData={props.sendUsersData}
			/>
			<CompanyReg
				eventTypes={props.eventTypes}
				cbDataForEduServices={cbDataForEduServices}
				nextStep={props.nextStep}
				isCompanyReg={userType === "company"}
				currentLead={currentLead}
				eventCode={props.eventCode}
				pageCode={props.pageCode}
				user={props.user}
				checkPolicy={props.checkPolicy}
				sendUsersData={props.sendUsersData}
			/>
		</div>
	);
};